/**
 * @desc 获取币种列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<string>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/currency/getList`, {
      method: "POST",

      ...options,
    }),
  );
}
